import { Badge, Tooltip } from 'antd'
import { EKPIUnit } from 'enums/kpi'
import { IPieChartColor } from 'models/dashboardSetting'
import React from 'react'
import { Cell, Legend, Pie, PieChart, PieProps, ResponsiveContainer } from 'recharts'
import NumberUtil from 'utils/number'
import { useTooltipContext } from '../BaseTooltip/CustomTooltip'

interface BasePieChartProps {
  data: Array<{
    id: number
    name: string
    value: number
    color: string
  }>
  colors: IPieChartColor[]
}

const renderLegend = (props: any) => {
  const { payload } = props
  return (
    <ul>
      {payload.map((entry: any, index: number) => (
        <li key={`item-${index}`} className='flex gap-2 text-[10px] items-center justify-start text-neutral-700'>
          <span className='flex flex-1 gap-2 m-0 items-center text-nowrap'>
            <Badge color={entry.color} />
            <Tooltip title={entry.value}>
              <span className='font-[450] text-[10px] h-full w-[100px] truncate'>{entry.value}</span>
            </Tooltip>
          </span>
          <span className='flex-1 font-[650]'>
            {entry?.payload?.payload?.value ? NumberUtil.format(entry.payload.payload.value?.toFixed(2)) : '0.00'}
          </span>
        </li>
      ))}
    </ul>
  )
}

const BasePieChart: React.FC<BasePieChartProps> = ({ data, colors }) => {
  const { openTooltip, closeTooltip } = useTooltipContext()

  const tooltipContent = (e: any) => {
    return <span>{e && NumberUtil.format(e.toFixed(2), { unit: EKPIUnit.PERCENT })}</span>
  }
  const total = data.reduce((acc, cur) => acc + cur.value, 0)

  const dataFormat = data.map((dataItem) => {
    const colorItem = colors?.find((color) => color?.id === dataItem.id)

    return {
      ...dataItem,
      percent: (dataItem.value * 100) / total,
      color: colorItem ? colorItem.value : ''
    }
  })

  const onPieEnter: PieProps['onMouseEnter'] = (e) => {
    openTooltip({
      content: tooltipContent(e.tooltipPayload[0].value)
    })
  }

  return (
    <ResponsiveContainer width='100%' height='100%'>
      <PieChart className='w-full h-full'>
        <Pie
          labelLine={false}
          data={dataFormat}
          cx={'50%'}
          cy={'50%'}
          outerRadius={80}
          paddingAngle={0}
          onMouseEnter={onPieEnter}
          onMouseLeave={() => {
            closeTooltip()
          }}
          dataKey={'percent'}
          blendStroke={true}
        >
          {dataFormat.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} style={{ outline: 'none' }} />
          ))}
        </Pie>
        <Legend layout='vertical' align='right' content={renderLegend} />
      </PieChart>
    </ResponsiveContainer>
  )
}

export default BasePieChart
